import { getUriHostname } from 'helpers/url';
import { isURLWithProtocol } from 'helpers/validate';

export function getReferrerHostname(cameFromURL: string): string | null {
  const urlTrimmed = cameFromURL?.trim();

  return (urlTrimmed && isURLWithProtocol(urlTrimmed) && getUriHostname(urlTrimmed)) || null;
}
